//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  it: "اٹلی",
  ar: "ارجنٹینا",
  jo: "اردن",
  aw: "اروبا",
  er: "اریٹیریا",
  uz: "ازبکستان",
  gq: "استوائی گیانا",
  ee: "اسٹونیا",
  il: "اسرائیل",
  af: "افغانستان",
  sv: "ال سلواڈور",
  al: "البانیہ",
  dz: "الجیریا",
  um: "امریکہ سے باہر کے چھوٹے جزائز",
  as: "امریکی ساموآ",
  vi: "امریکی ورجن آئلینڈز",
  aq: "انٹارکٹیکا",
  ag: "انٹیگوا اور باربودا",
  ad: "انڈورا",
  id: "انڈونیشیا",
  ao: "انگولا",
  ai: "انگوئیلا",
  et: "ایتھوپیا",
  ir: "ایران",
  ec: "ایکواڈور",
  az: "آذربائیجان",
  am: "آرمینیا",
  at: "آسٹریا",
  au: "آسٹریلیا",
  ax: "آلینڈ آئلینڈز",
  ie: "آئرلینڈ",
  is: "آئس لینڈ",
  im: "آئل آف مین",
  bb: "بارباڈوس",
  bh: "بحرین",
  br: "برازیل",
  vg: "برٹش ورجن آئلینڈز",
  io: "برطانوی بحر ہند کا علاقہ",
  bf: "برکینا فاسو",
  bm: "برمودا",
  bn: "برونائی",
  bi: "برونڈی",
  bg: "بلغاریہ",
  bd: "بنگلہ دیش",
  bw: "بوتسوانا",
  ba: "بوسنیا اور ہرزیگووینا",
  bo: "بولیویا",
  bv: "بؤویٹ آئلینڈ",
  bs: "بہاماس",
  by: "بیلاروس",
  bz: "بیلائز",
  be: "بیلجیم",
  bj: "بینن",
  in: "بھارت",
  bt: "بھوٹان",
  pg: "پاپوآ نیو گنی",
  pk: "پاکستان",
  pa: "پانامہ",
  pn: "پٹکائرن جزائر",
  pt: "پرتگال",
  pw: "پلاؤ",
  pl: "پولینڈ",
  py: "پیراگوئے",
  pe: "پیرو",
  pr: "پیورٹو ریکو",
  tj: "تاجکستان",
  tw: "تائیوان",
  tm: "ترکمانستان",
  tr: "ترکی",
  tt: "ترینیداد اور ٹوباگو",
  tz: "تنزانیہ",
  tn: "تونس",
  tl: "تیمور لیسٹ",
  th: "تھائی لینڈ",
  tc: "ٹرکس اور کیکوس جزائر",
  tk: "ٹوکیلاؤ",
  tg: "ٹوگو",
  to: "ٹونگا",
  tv: "ٹووالو",
  jp: "جاپان",
  ge: "جارجیا",
  gi: "جبل الطارق",
  dj: "جبوتی",
  je: "جرسی",
  de: "جرمنی",
  fo: "جزائر فارو",
  cx: "جزیرہ کرسمس",
  jm: "جمائیکا",
  do: "جمہوریہ ڈومينيکن",
  za: "جنوبی افریقہ",
  gs: "جنوبی جارجیا اور جنوبی سینڈوچ جزائر",
  ss: "جنوبی سوڈان",
  kr: "جنوبی کوریا",
  td: "چاڈ",
  cl: "چلی",
  cz: "چیکیا",
  cn: "چین",
  dk: "ڈنمارک",
  dm: "ڈومنیکا",
  rw: "روانڈا",
  ru: "روس",
  ro: "رومانیہ",
  re: "ری یونین",
  us: "ریاست ہائے متحدہ امریکہ",
  zm: "زامبیا",
  zw: "زمبابوے",
  ws: "ساموآ",
  sm: "سان مارینو",
  st: "ساؤ ٹومے اور پرنسپے",
  rs: "سربیا",
  lk: "سری لنکا",
  sc: "سشلیز",
  sa: "سعودی عرب",
  gb: "سلطنت متحدہ",
  sk: "سلوواکیہ",
  si: "سلووینیا",
  sx: "سنٹ مارٹن",
  sg: "سنگاپور",
  sz: "سواتنی",
  sj: "سوالبرڈ اور جان ماین",
  sd: "سوڈان",
  sr: "سورینام",
  sb: "سولومن آئلینڈز",
  ch: "سوئٹزر لینڈ",
  se: "سویڈن",
  sl: "سیرالیون",
  bl: "سینٹ برتھلیمی",
  pm: "سینٹ پیئر اور میکلیئون",
  kn: "سینٹ کٹس اور نیویس",
  lc: "سینٹ لوسیا",
  mf: "سینٹ مارٹن",
  vc: "سینٹ ونسنٹ اور گرینیڈائنز",
  sh: "سینٹ ہیلینا",
  sn: "سینیگل",
  sy: "شام",
  kp: "شمالی کوریا",
  mp: "شمالی ماریانا آئلینڈز",
  mk: "شمالی مقدونیہ",
  so: "صومالیہ",
  iq: "عراق",
  om: "عمان",
  fk: "فاکلینڈ جزائر",
  fj: "فجی",
  fr: "فرانس",
  pf: "فرانسیسی پولینیشیا",
  tf: "فرانسیسی جنوبی خطے",
  gf: "فرینچ گیانا",
  ph: "فلپائن",
  ps: "فلسطینی خطے",
  fi: "فن لینڈ",
  cy: "قبرص",
  kz: "قزاخستان",
  qa: "قطر",
  cg: "کانگو - برازاویلے",
  cd: "کانگو - کنشاسا",
  kg: "کرغزستان",
  hr: "کروشیا",
  ki: "کریباتی",
  bq: "کریبیائی نیدرلینڈز",
  ck: "کک آئلینڈز",
  kh: "کمبوڈیا",
  ci: "کوٹ ڈی آئیوری",
  cr: "کوسٹا ریکا",
  cc: "کوکوس (کیلنگ) جزائر",
  co: "کولمبیا",
  km: "کوموروس",
  kw: "کویت",
  cv: "کیپ ورڈی",
  cm: "کیمرون",
  ky: "کیمین آئلینڈز",
  ke: "کینیا",
  ca: "کینیڈا",
  cu: "کیوبا",
  cw: "کیوراکاؤ",
  gl: "گرین لینڈ",
  gd: "گریناڈا",
  gn: "گنی",
  gw: "گنی بساؤ",
  gt: "گواٹے مالا",
  gp: "گواڈیلوپ",
  gu: "گوام",
  gg: "گوئرنسی",
  gy: "گیانا",
  ga: "گیبون",
  gm: "گیمبیا",
  gh: "گھانا",
  la: "لاؤس",
  lr: "لائبیریا",
  lb: "لبنان",
  lv: "لٹویا",
  lu: "لکسمبرگ",
  ly: "لیبیا",
  lt: "لیتھونیا",
  ls: "لیسوتھو",
  li: "لیشٹنسٹائن",
  mq: "مارٹینک",
  mh: "مارشل آئلینڈز",
  mu: "ماریشس",
  mt: "مالٹا",
  md: "مالدووا",
  mv: "مالدیپ",
  ml: "مالی",
  fm: "مائکرونیشیا",
  yt: "مایوٹ",
  ae: "متحدہ عرب امارات",
  mg: "مڈغاسکر",
  ma: "مراکش",
  eg: "مصر",
  eh: "مغربی صحارا",
  mo: "مکاؤ SAR چین",
  mw: "ملاوی",
  my: "ملائشیا",
  mn: "منگولیا",
  mr: "موریطانیہ",
  mz: "موزمبیق",
  mc: "موناکو",
  ms: "مونٹسیراٹ",
  me: "مونٹے نیگرو",
  mm: "میانمار (برما)",
  mx: "میکسیکو",
  nf: "نارفوک آئلینڈ",
  no: "ناروے",
  na: "نامیبیا",
  ne: "نائجر",
  ng: "نائجیریا",
  ni: "نکاراگووا",
  nr: "نؤرو",
  np: "نیپال",
  nl: "نیدر لینڈز",
  nc: "نیو کلیڈونیا",
  nz: "نیوزی لینڈ",
  nu: "نیئو",
  cf: "وسط افریقی جمہوریہ",
  vn: "ویتنام",
  va: "ویٹیکن سٹی",
  wf: "ویلیز اور فیوٹیونا",
  ve: "وینزوئیلا",
  vu: "وینوآٹو",
  hk: "ہانگ کانگ SAR چین",
  es: "ہسپانیہ",
  hu: "ہنگری",
  hn: "ہونڈاروس",
  ht: "ہیٹی",
  hm: "ہیرڈ جزیرہ و میکڈولینڈ جزائر",
  ye: "یمن",
  uy: "یوروگوئے",
  ua: "یوکرین",
  ug: "یوگنڈا",
  gr: "یونان",
};
